<template>
  <div class="register-protocol protocol-mask" v-show="ifProtocol">
    <div class="protocol-mask-conn">
      <h1>《庆源绿色金融服务协议》{{ protocolName }}</h1>
      <div class="information" v-html="serviceProtocol">
        <p class="line">
          庆源资管平台依据以下条件和条款为您提供所享有的服务，请仔细阅读并遵守。
        </p>
        <p class="line">
          欢迎阅读庆源资管平台“庆源资管平台用户注册及使用协议”（下称“本协议”）。本协议阐述之条款和条件适用于您使用庆源资管平台（所涉域名为http://www.qylsbl.com/bpsWeb）
          ，及庆源资管平台未来或现在开设的手机客户端、无线端载体等），所提供的全面网上服务，该平台提供的服务包括但不限于保理融资管理、风险防范和提高管理效率等方面提供全方位综合服务的平台（下称“服务”）。
        </p>
        <h2>一、接受条款</h2>
        <p class="line">
          1．本协议内容包括协议正文及所有庆源资管平台已经发布或将来可能发布的各类规则、细则、协议等各类文本等。所有规则等均为本协议不可分割的一部分，与协议正文具有同等法律效力。
        </p>
        <p class="line">
          2．注册时点选接受“庆源资管平台用户注册及使用协议”或以任何方式进入庆源资管平台（下称“平台”）网站并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件（以下合称“条款”），并承诺按照条款的约定及平台的程序设置等享受权利、履行义务。
        </p>
        <p class="line">
          2.1您通过http://www.qylsbl.com/bpsWeb登录庆源资管平台的，则您将成为庆源资管平台的用户。
        </p>
        <p class="line">
          2.2你同意您在庆源资管平台账号和该账号关联的信息或系统的相关信息可以展示于平台。
        </p>
        <p class="line">
          3．庆源资管平台有权根据业务需要酌情修订“条款”，并以公告的形式进行更新，不再单独通知予您。经修订的“条款”一经在网站公布，即产生效力。如您不同意相关修订，请立即停止使用“服务”，并于“条款”修改公布之日起7日内以书面的形式按平台公布的联系方式提出异议。如您继续使用“服务”，则将视为您已接受经修订的“条款”，当您与平台发生争议时，应以最新的“条款”为准。
        </p>
        <h2>二、注册</h2>
        <p class="line">
          1.平台用户加入平台开展业务，遵循自愿原则。通过平台开展业务应注册为平台用户；平台用户注册信息变更的，应及时变更注册信息；平台用户终止使用平台的，应申请注销用户。
        </p>
        <p class="line">
          2.注册用户时，机构或个人应登录平台网站填写注册信息、上传实名认证材料，机构上传的实名认证材料包括但不限于营业执照、组织机构代码证、税务登记证，企业法定代表人身份证件信息及其联系方式，个人需上传的实名认证材料包括但不限于本人身份证件信息及其联系方式。本平台对用户提供的材料进行审查，确认其身份真实性后，为其开通平台用户权限。
        </p>
        <p class="line">
          3.平台用户注册时应保证填写及提供的身份资料和信息真实、准确、完整，并自行承担因提交信息或资料不实而引起的法律责任。
        </p>
        <p class="line">
          4.注册成功后，每位平台用户都拥有一个属于自己的用户名和登录密码。平台用户应妥善保管用户名、密码、验证信息等，并只将用户名、密码、验证信息披露给有权限的工作人员。用户名、密码使用权仅属于平台用户，平台用户不得赠与、借用、租用、转让或者售卖其用户名。
        </p>
        <p class="line">
          5.用户同意并授权本平台审核、核对用户资料信息。本平台有权全面审核用户提交的资料以确认用户真实身份，确保后续服务的合法性、有效性。
        </p>
        <h2>三、账户安全</h2>
        <p class="line">
          您须自行负责对您的平台登录名、密码保密，且须对该登录名、密码下发生的所有活动（包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。
        </p>
        <h2>四、关于费用</h2>
        <p class="line">
          1.本平台自身暂不向平台用户收取服务费用。但是，平台为向平台用户提供本协议项下服务而需要代收代付的款项，譬如本平台根据本协议及平台业务规则代平台用户通过接口查询和接口登记等方式向中登网办理应收账款转让登记而应向中登网支付的相关登记费用，本平台不予垫付，应由平台用户先行支付给本平台。
        </p>
        <p class="line">
          2.本平台保留单方面制定与调整服务费用的权利。费用标准一旦被修改，即公布在本平台上，修改后的费用标准一经公布即生效，适用于费用标准修改后发生的交易。
        </p>
        <h2>五、不可抗力</h2>
        <p class="line">
          对于因庆源资管平台及平台合作方合理控制范围以外的原因，包括但不限于自然灾害、罢工或骚乱、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等，致使庆源资管平台及平台合作方延迟或未能履约的，庆源资管平台不对您承担任何责任。
        </p>
        <!--<p class="line">2．平台网站仅作为用户选择交易对象，就资产的交易进行协商，以及获取各类与资产相关的服务。同时，合盈小额贷款(重庆)有限公司平台不涉及会员间因交易而产生的法律关系及法律纠纷。</p>-->
        <!--<p class="line">3．合盈小额贷款(重庆)有限公司平台与<span class="underline">/</span>为合作关系，<span class="underline">/</span>为合盈小额贷款(重庆)有限公司平台合作方（下称“平台合作方”）。<span class="underline">/</span>为平台会员提供与<span class="underline">/</span>的信息传输服务和技术支持；<span class="underline">/</span>为合盈小额贷款(重庆)有限公司平台会员提供线上支付、结算等资金账户管理服务，会员将在线上与<span class="underline">/</span>另行签署协议约定相关的权利义务。如上述服务出现问题，平台会员应穷尽一切可能及时联络平台及平台合作方，平台将协助会员与平台合作方进行沟通协调。</p>-->
        <h2>六、法律适用、管辖及其他</h2>
        <p class="line">
          1.本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，如无相关法律规定的，则应参照通用的商业惯例和（或）行业惯例。
        </p>
        <p class="line">
          2.您认可庆源资管平台已经发布的以及将来可能发布的各类规则、细则、协议等各类文本属于本协议的一部分，与本协议正文具有同等法律效力。
        </p>
        <p class="line">
          3.您同意庆源资管平台因经营业务需要有权将本协议项下的权利义务就部分或全部进行转让，而无须再通知予您并取得您的同意。
        </p>
        <p class="line">
          4.因本协议或庆源资管平台的服务所引起或与其有关的任何争议应向平台所在地有管辖权的人民法院提起诉讼。
        </p>
        <p class="line">
          5.条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。平台未就您或其他人的某项违约行为采取行动，并不表明平台撤回就任何继后或类似的违约事件采取行动的权利。
        </p>
        <p class="line">
          6.若本协议任何条款被裁定为无效或不可强制执行时，该项条款应被撤销，而其余条款应予遵守和执行。
        </p>
      </div>
    </div>
    <div class="oper">
      <el-button type="primary" @click="agree">同意并继续</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifProtocol: false,
      protocolName: "",
      serviceProtocol: ""
    };
  },
  created() {
    this.getServiceProtocol();
  },
  methods: {
    show() {
      this.ifProtocol = true;
    },

    closeProtocol() {
      this.ifProtocol = false;
    },

    getServiceProtocol() {
      this.$request.account_protocol().then(res => {
        const { protocalTitle, protocalContent } = res;
        this.serviceProtocol = protocalContent;
        this.$emit("on-update", protocalTitle);
      });
    },

    agree() {
      this.ifProtocol = false;
      this.$emit("on-agree");
    }
  }
};
</script>

<style lang="scss">
.register-protocol {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  left: 0;
  padding: 20px;
  width: 100%;
  height: 90vh;
  background: #fff;
  box-sizing: border-box;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;

  .protocol-mask-conn {
    height: calc(100% - 60px);
    overflow-y: auto;
  }

  h1 {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    text-align: center;
  }

  h2 {
    margin-top: 10px;
    font-size: 16px;
  }

  .information {
    line-height: 26px;
    overflow-y: auto;
    font-size: 13px;
  }

  .oper {
    display: flex;
    justify-content: center;
  }
}
</style>
